// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"339843a0","496":"640516ce"}[chunkId] + ".chunk.js";
};